import { GetFieldDefBy } from "./GetFieldDefBy";

export function GetObjecDBLevel(dataObject) {
  if (dataObject == null) return null;

  var levelDef = dataObject.GetFieldDefByID("Level");
  var objLevel = dataObject.GetFieldValue(levelDef);
  return objLevel;
}
